import React from 'react'
import Countdown from 'react-countdown'

function n(n) {
    return n > 9 ? "" + n : "0" + n;
}

function CountDownX(pr) {

    const Completionist = () => <span style={{ color: "red" }}> <b>  Pembayaran Expire</b></span>;


    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            return <Completionist />;
        } else {
            // Render a countdown
            return (
                <h3 className='bg-warning p-1 rounded'>
                    <b>
                        {n(hours)}:{n(minutes)}:{n(seconds)}
                    </b>
                </h3>
            );
        }
    };

    return (
        <Countdown
            date={pr.tgl}
            intervalDelay={0}
            precision={3}
            renderer={renderer}
        />
    )
}

export default CountDownX